import { render, staticRenderFns } from "./SupportTicketCard.vue?vue&type=template&id=7654c9cc"
import script from "./SupportTicketCard.vue?vue&type=script&lang=js"
export * from "./SupportTicketCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports